function AboutBlock({ smallTitle, mainTitle, description, image }) {
  return (
    <section className="block about-block">
      <div className="about-content">

        <div className="about-image">
          {image && <img src={image} alt="About Us" />}
        </div>

        <div className="about-text">
          <h4 className="small-title">{smallTitle || ''}</h4>
          <h2 className="main-title">{mainTitle || ''}</h2>

          <p>
            {description || ''}
          </p>
        </div>

      </div>
    </section>
  );
}

export default AboutBlock;
